<template>
  <div class="measure-filter-editor">
    <div class="ref-select w-full mb-4">
      <MeasureEditor
        v-model="measure"
        v-bind="subObjectBinds" />
    </div>
    <div style="font-size: 13px">
      Filter Criteria {{ comparison }}
    </div>
    <singleselect
      v-model="comparison"
      :options="comparisonOptions"
      :return-as-object="false"
      :enable-search="false"
      label="label"
      track-by="key" />
    <validationErrors :errors="comparisonErrors" />

    <span
      style="font-size: 13px;"
      class="mt-3">Value </span>
    <b-input
      v-model="filterValue"
      class="mt-3"
      type="number" />
    <validationErrors :errors="filterValueErrors" />
  </div>
</template>

<script>
  import singleselect from '@/components/ui/singleselect.vue'
  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import { mapChildren } from '@/components/reports/config/common/objectUtil'

  export default {
    name: 'MeasureFilterEditor',
    components: {
      singleselect,
    },
    mixins: [ObjectEditorMixin,],
    data () {
      return {
        comparisonOptions: [
          {
            key: 'is_more',
            label: '>',
          },
          {
            key: 'is_more_or_equal',
            label: '≥',
          },
          {
            key: 'is_less',
            label: '<',
          },
          {
            key: 'is_less_or_equal',
            label: '≤',
          },
          {
            key: 'is',
            label: '=',
          },
        ],
      }
    },
    computed: {
      ...mapChildren({
        measure: 'measure',
        comparison: 'comparison',
        filterValue: 'value',
      }),
    },
  }
</script>

<style lang="scss" scoped>
.measure-filter-editor {
  display: flex;
  flex-direction: column;
}
.ref-select {
  display: flex;
  flex-direction: row;
}
</style>
